import React from 'react';
import "./LandingPage.css";
import { InfoGlyph } from '../components/InfoGlyph';
import { Grid, GridCell } from 'rmwc/Grid';
import { Button } from 'rmwc/Button';
import { AboutPage } from "./AboutPage";

const LandingPage = () => (
  <div>
  <div className="landing-page">
    <Grid className="top-grid">
      <GridCell span="12">
        <div className="top-grid-cell">
          <div style={{backgroundColor:"rgba(0, 0, 0, 0.5)", paddingLeft:"10px", paddingRight:"10px"}}>
            <div style={{color:"white", fontFamily:"Allerta Stencil", fontSize: "30px"}}>Networking made easy with NetworkBuddy</div>
            <div style={{color:"white", fontSize: "18px", paddingTop:"25px", paddingBottom:"5px"}}>Learn to network with an experienced networker by your side. Never go to an event alone again.</div>
          </div>
          <div style={{paddingTop:"15px"}}>
            <Button style={{height:"70px", width:"300px", backgroundColor: "#ec6f32", fontSize: "18px", padding:"15px", color:"white", borderRadius:"2px", border:"0.6px solid white"}}
              raised
              onClick={e => {window.open("https://www.facebook.com/groups/networkbuddygroup/");}}

            >
            Join the Secret Club
            </Button>
          </div>
        </div>
      </GridCell>
    </Grid>

    <Grid style={{maxWidth:"1280px"}}>
      <GridCell desktop="3" phone="4">
        <InfoGlyph
          href={"./events"}
          icon={"search"}
          title={"Search Events"}
          text={"Find Networking Events across a wide range of sites and platforms – all in one place, and see who’s going."}
        />
      </GridCell>
      <GridCell desktop="3" phone="4">
        <InfoGlyph
          href={"./captureevent"}
          icon={"view_list"}
          title={"Add Events"}
          text={"Join and list your events for free – plus list any event where you will be attending and willing to Buddy."}
        />
      </GridCell>
      <GridCell desktop="3" phone="4">
        <InfoGlyph
          href={"https://www.facebook.com/groups/networkbuddygroup/"}
          target="blank"
          icon={"people"}
          title={"Be a Buddy"}
          text={"Help others by becoming a buddy at the events you are attending. Find the event and tick the box. Connect and Go!"}
        />
      </GridCell>
      <GridCell desktop="3" phone="4">
        <InfoGlyph
          href={"./events"}
          icon={"face"}
          title={"Find a Buddy"}
          text={"Connect with experienced networkers ahead of time, and have someone with you to break the ice. No more awkward fake phone calls."}
        />
      </GridCell>

    </Grid>
  </div>
  <AboutPage />
  </div>
);

export default LandingPage;


/*

<Grid container className="landingPage">
  <Grid container>

    <Grid item xs={12} sm={6} style={{paddingTop:"155px"}}>
      <Grid container justify="center">
        <div style={{width:"375px"}}>
          <div style={{backgroundColor:"rgba(0, 0, 0, 0.5)"}}>
            <div style={{color:"white", fontFamily:"Allerta Stencil", fontSize: "2em"}}>Networking made easy with NetworkBuddy</div>
            <div style={{color:"white", fontSize: "1.3em", paddingTop:"25px", paddingBottom:"5px"}}>Learn to network with an experienced networker by your side. Never go to an event alone again.</div>
          </div>
          <div style={{paddingTop:"10px"}}>
            <Button style={{backgroundColor: "#ec6f32", fontSize: "1.3em", padding:"15px", color:"white"}}
              raised
              href="https://www.facebook.com/groups/networkbuddygroup/" target="blank"
            >
            Join the Secret Club
            </Button>
          </div>
        </div>
      </Grid>
    </Grid>

  </Grid>

  <Grid container style={{paddingTop:"75px", marginLeft:"50px", marginRight:"50px"}}>
    <Grid item xs={12} sm={3} >
      <InfoGlyph
        href={"/events"}

        glyph={<SearchIcon  style={{fontSize:"3em"}}/>}
        title={"Search Events"}
        text={"Find Networking Events across a wide range of sites and platforms – all in one place, and see who’s going."}
      />
    </Grid>
    <Grid item xs={12} sm={3}>
      <InfoGlyph
        href={"https://www.facebook.com/groups/networkbuddygroup/"}
        glyph={<ViewListIcon  style={{fontSize:"3em"}}/>}
        title={"Event Listing"}
        text={"Join and list your events for free – plus list any event where you will be attending and willing to Buddy."}
      />
    </Grid>
    <Grid item xs={12} sm={3}>
      <InfoGlyph
        href={"https://www.facebook.com/groups/networkbuddygroup/"}
        glyph={<PeopleIcon  style={{fontSize:"3em"}}/>}
        title={"Be a Buddy"}
        text={"Help others by becoming a buddy at the events you are attending. Find the event and tick the box. Connect and Go!"}
      />
    </Grid>
    <Grid item xs={12} sm={3}>
      <InfoGlyph
        href={"https://www.facebook.com/groups/networkbuddygroup/"}
        glyph={<FaceIcon  style={{fontSize:"3em"}}/>}
        title={"Find a Buddy"}
        text={"Connect with experienced networkers ahead of time, and have someone with you to break the ice. No more awkward fake phone calls."}
      />
    </Grid>
  </Grid>
</Grid>
*/



// WEBPACK FOOTER //
// ./src/containers/LandingPage.js